export const appConfig = {
  // to list the count of steps in the footer of listing layout
  showListingStepCount: false,
  // to signout immediately after new user registered
  directLogin: true
};
